import { createContext, FC, ReactNode, useContext, useState } from 'react'
import { getSlides, Slide } from 'utils/getData'

interface Props {
  children: ReactNode
}

interface SceneProviderValue {
  selectedSlide: Slide
  partSelectorDirection: number
  showTable: boolean
  toggleShowTable: () => void
  setSelectedSlide: (slide: Slide) => void
  setSelectedSlideFromId: (slideId: string) => void
  selectNextSlide: () => void
  selectPreviousSlide: () => void
  deselectSlide: () => void
}

const SceneContext = createContext<SceneProviderValue>({
  selectedSlide: getSlides()[0],
  partSelectorDirection: 0,
  showTable: true,
  toggleShowTable: () => {},
  setSelectedSlideFromId: () => {},
  setSelectedSlide: () => {},
  selectNextSlide: () => {},
  selectPreviousSlide: () => {},
  deselectSlide: () => {},
})

const SceneProvider: FC<Props> = ({ children }) => {
  // const [initiated, setInitiated] = useState<boolean>(false)
  const [selectedSlide, setSelectedSlide] = useState<Slide>(getSlides()[0])
  const [partSelectorDirection, setPartSelectorDirection] = useState<number>(1)
  const [showTable, setShowTable] = useState<boolean>(false)

  // useEffect(() => {
  //   setTimeout(() => {
  //     if (!initiated) {
  //       setSelectedSlide(selectedSlide)
  //       setInitiated(true)
  //     }
  //   }, 3000)
  // }, [showTable, initiated, selectedSlide])

  const deselectSlide = () => {
    setSelectedSlide(getSlides()[0])
  }

  const toggleShowTable = () => {
    setShowTable(!showTable)
  }

  const setSelectedSlideFromId = (slideId: string) => {
    const slides = getSlides()
    const slide = slides.find((slide) => slide.id === slideId)
    if (slide) {
      setSelectedSlide(slide)
    }
  }

  const selectNextSlide = () => {
    const slides = getSlides()
    if (selectedSlide) {
      const currentIndex = slides.findIndex((slide) => slide.id === selectedSlide?.id)
      setPartSelectorDirection(1)
      const nextIndex = currentIndex + 1
      if (nextIndex < slides.length) {
        const nextSlide = slides[nextIndex]
        setSelectedSlide(nextSlide)
      } else {
        setSelectedSlide(slides[0])
      }
    } else {
      setSelectedSlide(slides[0])
    }
  }

  const selectPreviousSlide = () => {
    const slides = getSlides()
    if (selectedSlide) {
      const currentIndex = slides.findIndex((slide) => slide.id === selectedSlide?.id)
      setPartSelectorDirection(-1)
      const previousIndex = currentIndex - 1
      if (previousIndex >= 0) {
        const previousSlide = slides[previousIndex]
        setSelectedSlide(previousSlide)
      } else {
        setSelectedSlide(slides[slides.length - 1])
      }
    } else {
      setSelectedSlide(slides[slides.length - 1])
    }
  }

  return (
    <SceneContext.Provider
      value={{
        showTable,
        deselectSlide,
        setSelectedSlideFromId,
        toggleShowTable,
        selectedSlide,
        partSelectorDirection,
        setSelectedSlide,
        selectNextSlide,
        selectPreviousSlide,
      }}
    >
      {children}
    </SceneContext.Provider>
  )
}

const useScene = () => useContext(SceneContext)

export { SceneContext, SceneProvider, useScene }
